import { render, staticRenderFns } from "./SDDSettings.vue?vue&type=template&id=4ba796ee&scoped=true&"
import script from "./SDDSettings.vue?vue&type=script&lang=js&"
export * from "./SDDSettings.vue?vue&type=script&lang=js&"
import style0 from "./SDDSettings.vue?vue&type=style&index=0&id=4ba796ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba796ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ba796ee')) {
      api.createRecord('4ba796ee', component.options)
    } else {
      api.reload('4ba796ee', component.options)
    }
    module.hot.accept("./SDDSettings.vue?vue&type=template&id=4ba796ee&scoped=true&", function () {
      api.rerender('4ba796ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/SDDSettings.vue"
export default component.exports